import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'footerMessage'
	| 'recordingDisclaimerMessage'
	| 'rovoBrandingLabel'
	| 'rovoBrandingLabelUpdated'
	| 'rovoBetaLabel'
	| 'recordingDisclaimerTooltip'
	| 'recordingDisclaimerIconLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		footerMessage: {
			id: 'ai-mate.footer.footer-message',
			defaultMessage: 'Uses AI. Verify results.',
			description: 'Footer message informing customer about the chatbot quality',
		},
		recordingDisclaimerMessage: {
			id: 'ai-mate.footer.recording-disclaimer-message',
			defaultMessage: 'Conversations in this agent are visible to people that manage this agent.',
			description:
				'Footer disclaimer informing the customer that their conversations may be recorded',
		},
		recordingDisclaimerTooltip: {
			id: 'ai-mate.footer.recording-disclaimer-tooltip',
			defaultMessage:
				'The people who manage this agent can see your conversation. Inactive conversations are deleted from storage 30 days after the most recent message.',
			description: 'Tooltip for the recording disclaimer',
		},
		recordingDisclaimerIconLabel: {
			id: 'ai-mate.footer.recording-disclaimer-icon-label',
			defaultMessage: 'Conversation review information',
			description:
				'Accessible label for the recording disclaimer information icon, which exposes more detail in a tooltip',
		},
		rovoBrandingLabel: {
			id: 'ai-mate.footer.rovo-branding-label',
			defaultMessage: '{logo} Rovo',
			description: 'Label to indicate the feature is powered by Rovo',
		},
		rovoBrandingLabelUpdated: {
			id: 'ai-mate.footer.rovo-branding-label-updated',
			defaultMessage: 'Rovo {logo}',
			description: 'Label to indicate the feature is powered by Rovo',
		},
		rovoBetaLabel: {
			id: 'ai-mate.footer.rovo-beta-label',
			defaultMessage: 'Beta',
			description: 'Label to indicate this is a beta feature',
		},
	});

export default message;
